import React, { FC } from 'react';
import styles from './login_form_group.module.scss';

export const LoginFormGroup: FC = ({ children }) => (
  <div className={styles.group}>{children}</div>
);
